
import React from 'react';
import { Job } from "@/components/jobs/types";
import { Label } from "@/components/ui/label";

interface JobClientInfoFieldProps {
  job: Pick<Job, 'client_name' | 'client_id'>;
}

export const JobClientInfoField: React.FC<JobClientInfoFieldProps> = ({ job }) => {
  if (!job.client_name && !job.client_id) {
    return null; // Don't render anything if no client info
  }

  return (
    <div>
      <Label className="text-xs font-medium text-muted-foreground">Client</Label>
      <p className="text-sm">
        {job.client_name || 'N/A'}
        {job.client_id && <span className="text-xs text-muted-foreground ml-1">(ID: {job.client_id})</span>}
      </p>
    </div>
  );
};
